const LOG_TYPE_PREFIXES: Record<string, string> = {
  otf: "otf_",
  transcription: "tr_",
};

/**
 * Logger entries are created in bursts (especially when several transcript
 * lines are launched together), so a millisecond timestamp is not a unique
 * identity. A collision makes React reuse the wrong card and causes deletion
 * by id to remove every entry sharing that timestamp.
 */
export const createTempLogId = (type?: string): string => {
  const prefix = LOG_TYPE_PREFIXES[type || ""] || "log_";
  return `${prefix}${Date.now()}_${crypto.randomUUID()}`;
};
